import React from "react";
import ScrollTrigger from "gsap/ScrollTrigger";
import ScrollToPlugin from "gsap/ScrollToPlugin";
import { gsap } from "gsap";
import "./styles.scss";
import { useEffect } from "react";

const Gallery = () => {
  useEffect(() => {
    gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);

    let hasPlayed = false;

    const animation = gsap
      .timeline({
        paused: true,
      })
      .to(".galleryContainer", {
        opacity: 1,
        y: -100,
      });

    ScrollTrigger.create({
      trigger: "#gallerySection",
      start: "-10% 80%",
      end: "30% 90%",
      onEnter: () => {
        if (!hasPlayed) {
          animation.play();
          hasPlayed = true;
        }
      },
    });
  }, []);

  const photos = [
    {
      id: "one",
      height: 400,
      background: "blue",
      width: "100%",
      img: require("../../assets/photos/one.jpeg"),
    },
    {
      id: "two",
      height: 400,
      background: "red",
      img: require("../../assets/photos/three.jpeg"),

      width: null,
    },
    {
      id: "three",
      height: 200,
      background: "purple",
      img: require("../../assets/photos/two.jpeg"),

      width: null,
    },
  ];

  return (
    <section id="gallerySection">
      <div className="galleryContainer">
        <img alt="barbershop" src={photos[0].img} className="picture" />
      </div>
      );
    </section>
  );
};

export default Gallery;
